import React from 'react';

export const CheckMarkIcon = ({
  className,
  width = 16,
  height = 16,
  color,
}) => (
  <svg
    data-testid="checkmark-icon"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      fill={color || 'currentColor'}
    />
    <path
      d="M7.03572 9.70619L11.3366 5.20301C11.5951 4.93233 12.0143 4.93233 12.2728 5.20301C12.5313 5.4737 12.5313 5.91257 12.2728 6.18325L7.03572 11.6667L3.99394 8.48183C3.73542 8.21115 3.73542 7.77228 3.99394 7.50159C4.25247 7.23091 4.67162 7.23091 4.93015 7.50159L7.03572 9.70619Z"
      fill="white"
    />
  </svg>
);
